// @mui
import {
  TableRow,
  TableCell,
  Typography,
  Button,
  Stack,
  Grid,
  Card,
  CardHeader,
  Divider,
  Table,
  TableBody,
  TableContainer,
  Box,
} from '@mui/material';
import Iconify from 'src/components/Iconify';
import { PATH_DASHBOARD } from 'src/routes/paths';
// @types

import { useNavigate } from 'react-router-dom';

import Scrollbar from 'src/components/Scrollbar';
import { TableHeadCustom } from 'src/components/table';
//Localization
import useLocales from 'src/hooks/useLocales';
import { IElectricMeter } from 'src/@types/Choqorak/Settings/ElectricMeter';
import HistoryComponent from '../../../MainTable/History/HistoryComponent';
import { IElectricityPayment } from 'src/@types/Choqorak/MainTables/ElectricityPayment/ElectricityPayment';

type Props = {
  row: IElectricMeter;
  clearElectricMeter: () => void;
  electricityRow?: IElectricityPayment[];
};

export default function ElectricMeterDetailTableRow({
  row,
  clearElectricMeter,
  electricityRow,
}: Props) {
  const { translate } = useLocales(); //Localization
  const navigate = useNavigate();

  // const { applicationId, name, description, application, id, permissions } = row;
  const TABLE_HEAD = [
    { id: 'id', label: `${translate('userElectricMeter.Id')}`, align: 'left' },
    { id: 'name', label: `${translate('userElectricMeter.PermissionName')}`, align: 'left' },
    { id: 'controller', label: `${translate('userElectricMeter.ControllerName')}`, align: 'left' },
    { id: 'action', label: `${translate('Department.Action')}`, align: 'left' },
    { id: 'method', label: `${translate('userElectricMeter.Method')}` },
    { id: 'application', label: `${translate('userElectricMeter.Application')}` },
    { id: 'description', label: `${translate('userElectricMeter.Description')}` },
  ];

  return (
    <>
      <Grid item xs={12}>
        <Card
          sx={{
            p: 3,
            mb: 3,
            backgroundColor: 'grey.800',
            color: 'grey.100',
            borderRadius: 2,
            boxShadow: 3,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {/* Electric Box Info */}
            <Box sx={{ flex: 1 }}>
              <Typography variant="h5" sx={{ mb: 1, fontWeight: 'bold' }}>
                {translate('ElectricBox.ElectricBox')}
              </Typography>

              <Table size="small" sx={{ width: 'auto' }}>
                <TableBody>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold' }}>
                      {translate('ElectricBox.ElectricBoxCode')}
                    </TableCell>
                    <TableCell>{row.electricBox}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold' }}>
                      {translate('ElectricMeter.ElectricMeterSerial')}
                    </TableCell>
                    <TableCell>{row.electricMeterSerial}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold' }}>{translate('Shop.ShopCode')}</TableCell>
                    <TableCell>{row.shopCode}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold' }}>
                      {translate('Customer.CustomerName')}
                    </TableCell>
                    <TableCell>{row.customerName}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold' }}>
                      {translate('ElectricMeter.ElectricityPrice')}
                    </TableCell>
                    <TableCell>{row.pricePerKilowat}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>

            {/* Electric Box Image */}
            <Box sx={{ flexShrink: 0, ml: 2 }}>
              <img
                src="/Images/electricbox.webp" // Replace with the actual path to the image
                alt={translate('electricBoxDetail.imageAlt')}
                style={{
                  width: '150px',
                  height: '150px',
                  borderRadius: '8px',
                  objectFit: 'cover',
                }}
              />
            </Box>
          </Box>
        </Card>
      </Grid>
      <HistoryComponent
        electricityRow={electricityRow}
        historyTitle={translate('ElectricMeter.ElectricMeter')}
      />
    </>
  );
}

//---------------------------------------------

// type PermissionDetailsProps = {
//   row: permissionsList;
// };

// function PermissionDetails({ row }: PermissionDetailsProps) {
//   return (
//     <TableRow>
//       <TableCell>{row.id}</TableCell>

//       <TableCell>{row.name}</TableCell>

//       <TableCell>{row.controller}</TableCell>

//       <TableCell>{row.action}</TableCell>
//       <TableCell>{row.method}</TableCell>
//       <TableCell>{row.application}</TableCell>
//       <TableCell>{row.description}</TableCell>
//     </TableRow>
//   );
// }
